import {
  lbPropositionApi,
  lbApiBeta,
  lbUserApi
} from '../../../utils/axiosConfig';

const DIMENSIONS = {
  mobile: '800x800',
  desktop: '1600x1600'
};

async function fetchUser(userId) {
  const { data: user } = await lbUserApi.get(`/user/${userId}`);
  window.Logger.log('Fetched user data: ', user);

  return user;
}

export async function fetchProposition({ propositionId, isMobile }) {
  const dimensions = DIMENSIONS[isMobile ? 'mobile' : 'desktop'];

  const { data: proposition } = await lbPropositionApi.get(
    `/propositions/${propositionId}?dimensions=${dimensions}`
  );

  return proposition;
}

async function fetchInterest(propositionId, propositionId2) {
  const { data: interestData } = await lbApiBeta(
    `/api/v2/interest/${propositionId}/${propositionId2}`
  );
  // 0 no, 1 yes, 2 yes as a super like (same scale as mark-interest).
  // `receivedSuperInterest` is set when the other party has super-liked
  // this swap: any present value counts, null/false/missing means none.
  const { interest, receivedSuperInterest } = interestData;
  return {
    interest: interest == null ? null : interest,
    receivedSuperInterest: !!receivedSuperInterest
  };
}

async function fetchFavourite(propositionId) {
  const { data: favouriteData } = await lbApiBeta.get(
    `api/v2/favourite/${propositionId}`
  );

  return favouriteData ? true : false;
}

async function fetchSponsoredPropositions(propositionId) {
  const {
    data: { data: propositions }
  } = await lbApiBeta.get(`/api/extravisibility/${propositionId}`);

  window.Logger.log('Sponsored propositions: ', propositions);

  return propositions;
}

async function fetchPropositionsSiteCount() {
  try {
    const { data } = await lbApiBeta.get(
      `/api/Statistics/GetStartpageStatistics`,
      {
        params: { date: new Date() }
      }
    );
    return data;
  } catch (e) {
    window.Logger.log('Error fetching total propositions count: ', e);
  }
}

async function sendTrustpilotReview() {
  try {
    await lbUserApi.post(`/review/send-user-request`);
    return true;
  } catch (e) {
    window.Logger.log('Error sending trustpilod review: ', e);
    return false;
  }
}

export default {
  fetchProposition,
  fetchSponsoredPropositions,
  fetchInterest,
  fetchFavourite,
  fetchUser,
  fetchPropositionsSiteCount,
  sendTrustpilotReview
};
